var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconClose24 = function SvgIconClose24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    style: {
      fill: "#006fba"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6131 5.84946L5.72402 5.72385C6.20467 5.24321 6.96097 5.20623 7.48403 5.61293L7.60964 5.72385L16.0002 14.1133L24.3907 5.72385C24.9114 5.20315 25.7556 5.20315 26.2763 5.72385C26.797 6.24455 26.797 7.08877 26.2763 7.60947L17.8868 16L26.2763 24.3905C26.7569 24.8712 26.7939 25.6275 26.3872 26.1505L26.2763 26.2761C25.7957 26.7568 25.0393 26.7938 24.5163 26.3871L24.3907 26.2761L16.0002 17.8867L7.60964 26.2761C7.08894 26.7968 6.24472 26.7968 5.72402 26.2761C5.20332 25.7554 5.20332 24.9112 5.72402 24.3905L14.1135 16L5.72402 7.60947C5.24338 7.12882 5.2064 6.37252 5.6131 5.84946L5.72402 5.72385L5.6131 5.84946Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClose24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-close-24.b932b48f.svg";
export { ForwardRef as ReactComponent };